import axios from 'axios'
import config from '../config'
import {getPatientToken} from '../utils'

const saveArticleLikeApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}article/like`,
        method: "post",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getPatientToken()}`
        }
    })

    return response

}

export default saveArticleLikeApi